<div id="bar" #bar class="bar{{index}}">
    <p *ngIf="!barData?.length" class="mt">No Data</p>
</div>
